<template>
    <DialogLayout>
        <cropper @change="() => {}" @close="handleClose"></cropper>
    </DialogLayout>
</template>

<script>
    import Cropper from "./Cropper";
    import ModalBus from "../../../eventBus";
    import DialogLayout from "../Layouts/DialogLayout";

    export default {
        components: {DialogLayout, Cropper},
        methods: {
            handleClose: function () {
                ModalBus.$emit('close')
            }
        }
    }
</script>
